import { Button } from '@bancobarigui/barihaus';

import { ProtectedRouteContainer } from '@/components/ProtectedRouteContainer';
import { PageHeader } from '@/components/PageHeader';
import { ServiceCheck, FeatureAlert } from '@/shared/components';
import { ElementGuard } from '@/components/PermissionGuard';
import { PlusOutlined } from '@ant-design/icons';
import { useChecklistsIndex } from './useChecklistsIndex';
import { ChecklistsFilterSection } from './ChecklistsFilterSection';
import { ChecklistsTableSection } from './ChecklistsTableSection';
import { UserPermissions } from '@/shared/enums/UserPermissions';

function ChecklistsIndexContent() {
  const {
    inspectionTypes,
    loadingInspectionTypes,
    selectedInspectionType,
    setSelectedInspectionType,
    showOnlyActive,
    setShowOnlyActive,
    columns,
    checklists,
    totalRecords,
    currentPage,
    pageSize,
    loading,
    error,
    handleNew,
    handleEdit,
    handleDelete,
    handleCopy,
    handleActivate,
    handleDeactivate,
    handlePageChange,
  } = useChecklistsIndex();

  return (
    <ProtectedRouteContainer
      pageHeader={
        <PageHeader
          title="Listagem de Checklists"
          actions={
            <ElementGuard permissions={[UserPermissions.checklist_create_bank]}>
              <Button
                htmlType="submit"
                buttonColor="primary"
                onClick={handleNew}
                icon={<PlusOutlined />}
              >
                Novo Checklist
              </Button>
            </ElementGuard>
          }
        />
      }
    >
      <FeatureAlert services={['checklist']} />
      <ServiceCheck services={['checklist']} featureName="Checklists">
        <ChecklistsFilterSection
          inspectionTypes={inspectionTypes}
          selectedInspectionType={selectedInspectionType}
          setSelectedInspectionType={setSelectedInspectionType}
          showOnlyActive={showOnlyActive}
          setShowOnlyActive={setShowOnlyActive}
          loadingInspectionTypes={loadingInspectionTypes}
        />

        <ChecklistsTableSection
          columns={columns}
          checklists={checklists}
          totalRecords={totalRecords}
          currentPage={currentPage}
          pageSize={pageSize}
          loading={loading}
          error={error}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
          handleCopy={handleCopy}
          handleActivate={handleActivate}
          handleDeactivate={handleDeactivate}
          handlePageChange={handlePageChange}
        />
      </ServiceCheck>
    </ProtectedRouteContainer>
  );
}

export default function ChecklistsIndex() {
  return <ChecklistsIndexContent />;
}
